/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RsaDevice } from '../../models/rsa-device';
import { RsaDeviceUpdateRequest } from '../../models/rsa-device-update-request';

export interface UpdateRsaDevice$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: RsaDeviceUpdateRequest
}

export function updateRsaDevice(http: HttpClient, rootUrl: string, params: UpdateRsaDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RsaDevice>> {
  const rb = new RequestBuilder(rootUrl, updateRsaDevice.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RsaDevice>;
    })
  );
}

updateRsaDevice.PATH = '/api/v1/rsa/devices/{id}';
